/**
 * @generated SignedSource<<2338d6fe45ab7bd0b29739ccf43b3cd8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespCreatorsComponents_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespFollowSearchBanner_user" | "SbSharedCreatorTopContent_user" | "SbSharedPageBreadcrumbs_user" | "SbSharedTitle_user" | "SharedFollowTopButton_user" | "SharedSaveSearchContext_user">;
  readonly " $fragmentType": "SbRespCreatorsComponents_user";
};
export type SbRespCreatorsComponents_user$key = {
  readonly " $data"?: SbRespCreatorsComponents_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespCreatorsComponents_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespCreatorsComponents_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedFollowTopButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedTitle_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedSaveSearchContext_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedPageBreadcrumbs_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedCreatorTopContent_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "3cca27cc0c874b497bd85f4420380a12";

export default node;
